import {
  PlayerName,
  PlayerProfile,
  PlayerSubheader
} from '@library/components/player';
import type { FormattedMemberReferral } from '@library/types/members/memberReferrals';
import { convertCentsToDollars } from '@library/utils/payments';

export interface MemberReferralsRowProps {
  memberReferral: FormattedMemberReferral;
}

export const MemberReferralsRow = ({
  memberReferral
}: MemberReferralsRowProps) => {
  const {
    depositAmount,
    depositDate,
    depositTime,
    deposited,
    email,
    name,
    referralId,
    signupDate,
    signupTime
  } = memberReferral;

  return (
    <div
      className="border-soFresh-140 text-soClean-110 hover:bg-soFresh-120 text-2xs relative flex h-full min-h-16 cursor-default items-center border-b xl:text-xs"
      data-testid={`member-referral-${referralId}`}
    >
      <PlayerProfile
        className="flex h-full w-[30%] shrink-0 basis-96 items-center gap-4 px-3"
        data-testid="member-referral-name"
        name={name}
        subheader={email}
      >
        <div className="flex shrink-0 flex-col">
          <PlayerName className="font-heebo text-soClean-100 block text-sm capitalize" />
          <PlayerSubheader className="text-soClean-170 font-heebo block text-xs" />
        </div>
      </PlayerProfile>
      <p className="w-[10%] px-3" data-testid="member-referral-id">
        {referralId}
      </p>
      <div className="w-1/5 px-3">
        <p data-testid="member-referral-signupDate">{signupDate}</p>
        <p
          className="text-soClean-160"
          data-testid="member-referral-signupTime"
        >
          {signupTime}
        </p>
      </div>
      <p className="w-[10%] px-3" data-testid="member-referral-deposited">
        {deposited ? 'Yes' : 'No'}
      </p>
      <div className="w-1/5 px-3">
        <p data-testid="member-referral-depositDate">{depositDate}</p>
        <p
          className="text-soClean-160"
          data-testid="member-referral-depositTime"
        >
          {depositTime}
        </p>
      </div>
      <p className="w-[10%] px-3" data-testid="member-referral-depositAmount">
        {depositAmount ? `${convertCentsToDollars(depositAmount)}` : ''}
      </p>
    </div>
  );
};
